/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./AdminLogin.css";
import { Textbox } from "../../assets/component/Textbox";
import { validLogin } from "../../assets/validators/login.js";
import { checkEmail } from "../../assets/validators/common.js";
import PropTypes from "prop-types";
import errorMsg from "../../assets/json/errMsg.json";
import { DEFAULT_LANGUAGE } from "../../config";
import { renderLanguageSelector } from "../../assets/component/renderLanguageSelector.js";

// Shown beside the globe; the native <select> on top does the switching.
export const LANGUAGE_LABELS = {
  zh: "繁體中文",
  cn: "简体中文",
  en: "English",
};

class AdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      checkData: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleChange(e) {
    this.setState({ username: e });
  }

  reroute() {
    // Validate here rather than trusting the last blur, so Enter works
    // straight after typing.
    if (!checkEmail(this.state.username)) {
      this.setState({ checkData: true });
      return;
    }
    this.props.history.push({
      pathname: "/AdminLoginPassword",
      state: {
        username: this.state.username,
      },
    });
  }

  render() {
    const languageObj = this.props.languageObj;
    const errMsgData =
      errorMsg[this.props.language] || errorMsg[DEFAULT_LANGUAGE];

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };

    return (
      <div className="AdminLogin-view">
        <div className="AdminLogin-topBar">
          <div className="AdminLogin-language">
            <svg
              className="AdminLogin-icon AdminLogin-iconSm"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            <span>{LANGUAGE_LABELS[this.props.language]}</span>
            <svg
              className="AdminLogin-icon AdminLogin-iconSm AdminLogin-chevron"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
            {renderLanguageSelector()}
          </div>
        </div>
        <div className="AdminLogin-card">
          <div className="AdminLogin-mark">
            <svg className="AdminLogin-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 3l7 3v5c0 4.5-3 8.3-7 9.5-4-1.2-7-5-7-9.5V6l7-3z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </div>

          <h1 className="AdminLogin-title">{languageObj.title}</h1>

          <p className="AdminLogin-subtitle">{languageObj.text}</p>

          <div className="AdminLogin-field" onKeyDown={handleKeyDown}>
            <label className="AdminLogin-label" htmlFor="email">
              {languageObj.emailLabel}
            </label>
            <Textbox
              id={"email"}
              name="email"
              type="email"
              placeholder={languageObj.inputFieldContainer}
              onChange={this.handleChange}
              value={this.state.username}
              classNameInput="AdminLogin-inputField"
              classNameContainer="AdminLogin-Container"
              validate={this.state.checkData}
              validationCallback={() => {
                this.setState({ checkData: false });
              }}
              onBlur={(e) => {}}
              validationOption={{
                ...validLogin.username(""),
                msgOnError: errMsgData.loginErr.loginEmailErr,
              }}
            />
          </div>

          <button
            type="button"
            onClick={this.reroute}
            className="AdminLogin-submit"
          >
            {languageObj.next}
            <svg
              className="AdminLogin-icon AdminLogin-iconSm"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}
AdminLogin.propTypes = {
  languageObj: PropTypes.object,
  language: PropTypes.string,
};

export default AdminLogin;
